/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/auth/exms-auth.provider.ts":
/*!****************************************!*\
  !*** ./src/auth/exms-auth.provider.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EXMSAuthProvider = exports.EXMSAuthProviderName = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const msal_auth_provider_1 = __webpack_require__(/*! ./msal-auth.provider */ "./src/auth/msal-auth.provider.ts");
;
exports.EXMSAuthProviderName = "EXMSAuthProvider";
class EXMSAuthProvider extends msal_auth_provider_1.MSALAuthProvider {
    constructor(props) {
        super(props);
    }
    initialiseClient() {
        if (this.props.loginFlow == "popup") {
            let electron = window.require("electron");
            this.ipcRenderer = electron.ipcRenderer;
        }
        else
            super.initialiseClient();
    }
    acquireToken(authParam, channel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { cache, name: provider } = this.props;
            const cacheName = `${provider}${authParam.name}`;
            const cacheResponse = cache
                ? smarthub_common_1.Cache.get(cacheName, cache)
                : null;
            if (cacheResponse)
                return {
                    response: cacheResponse
                };
            const response = this.ipcRenderer.invoke(channel, Object.assign(Object.assign({}, this.props), {
                authenticationParameters: Object.assign(Object.assign({}, authParam.request), {
                    state: authParam.name
                })
            }));
            smarthub_common_1.Cache.set(cacheName, response, cache);
            return {
                response
            };
        });
    }
    isLoggedIn() {
        const { cache, name: provider, loginToken } = this.props;
        const cacheName = `${provider}${loginToken.name}`;
        const response = cache
            ? smarthub_common_1.Cache.get(cacheName, cache)
            : null;
        return response != null;
    }
    loginPopup() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { loginToken } = this.props;
            return this.acquireToken(loginToken, "login");
        });
    }
    getTokenPopup(authParam) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.acquireToken(authParam, "token");
        });
    }
}
exports.EXMSAuthProvider = EXMSAuthProvider;


/***/ }),

/***/ "./src/auth/flex-auth.provider.ts":
/*!****************************************!*\
  !*** ./src/auth/flex-auth.provider.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FlexAuthProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class FlexAuthProvider {
    constructor(props) {
        this.props = props;
    }
    get name() {
        return this.props.name;
    }
    get authority() {
        return this.props.authorityName;
    }
    get serviceUsers() {
        return [this.props.tokenName];
    }
    getOptions(token) {
        const body = JSON.stringify({});
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body
        };
        if (token === null || token === void 0 ? void 0 : token.length)
            options.headers["Authorization"] = `Bearer ${token}`;
        return options;
    }
    fetchUser(authContext, serviceUser) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const { tokenName: name, cache, name: provider } = this.props;
                const cacheName = `${provider}${name}`;
                const cacheUser = cache
                    ? smarthub_common_1.Cache.get(cacheName, cache)
                    : null;
                if (cacheUser)
                    return cacheUser;
                const options = this.getOptions(serviceUser === null || serviceUser === void 0 ? void 0 : serviceUser.token);
                const response = yield fetch(this.props.uri, options);
                const user = yield response.json();
                if (cache)
                    smarthub_common_1.Cache.set(cacheName, user, cache);
                return user;
            }
            catch (ex) {
                smarthub_common_1.Logger.error("Failed to retrieve Flex user token", true, { ex });
            }
            return null;
        });
    }
    transformUser(user) {
        const { user: userName, source: serviceId, name: displayName, email, token } = user;
        const { tokenName: name, authorityName: authority, name: provider } = this.props;
        return {
            serviceUser: {
                authority,
                provider,
                name,
                serviceId,
                userName,
                token,
                properties: {
                    displayName,
                    email
                }
            }
        };
    }
    getServiceUser(name, authContext) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { serviceUser: sourceUser } = this.props;
            const { serviceUser, redirecting } = (sourceUser === null || sourceUser === void 0 ? void 0 : sourceUser.length) ? yield authContext.getServiceUser(sourceUser)
                : {};
            if (redirecting)
                return { redirecting };
            const user = yield this.fetchUser(authContext, serviceUser);
            return this.transformUser(user);
        });
    }
    logout() {
        return Promise.reject();
    }
}
exports.FlexAuthProvider = FlexAuthProvider;


/***/ }),

/***/ "./src/auth/index.ts":
/*!***************************!*\
  !*** ./src/auth/index.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FlexAuthProvider = exports.MSALAuthBaseProvider = exports.MSALAuthProvider = exports.EXMSAuthProviderName = exports.EXMSAuthProvider = void 0;
var exms_auth_provider_1 = __webpack_require__(/*! ./exms-auth.provider */ "./src/auth/exms-auth.provider.ts");
Object.defineProperty(exports, "EXMSAuthProvider", ({ enumerable: true, get: function () { return exms_auth_provider_1.EXMSAuthProvider; } }));
Object.defineProperty(exports, "EXMSAuthProviderName", ({ enumerable: true, get: function () { return exms_auth_provider_1.EXMSAuthProviderName; } }));
var msal_auth_provider_1 = __webpack_require__(/*! ./msal-auth.provider */ "./src/auth/msal-auth.provider.ts");
Object.defineProperty(exports, "MSALAuthProvider", ({ enumerable: true, get: function () { return msal_auth_provider_1.MSALAuthProvider; } }));
var msal_auth_base_provider_1 = __webpack_require__(/*! ./msal-auth-base.provider */ "./src/auth/msal-auth-base.provider.ts");
Object.defineProperty(exports, "MSALAuthBaseProvider", ({ enumerable: true, get: function () { return msal_auth_base_provider_1.MSALAuthBaseProvider; } }));
var flex_auth_provider_1 = __webpack_require__(/*! ./flex-auth.provider */ "./src/auth/flex-auth.provider.ts");
Object.defineProperty(exports, "FlexAuthProvider", ({ enumerable: true, get: function () { return flex_auth_provider_1.FlexAuthProvider; } }));


/***/ }),

/***/ "./src/auth/msal-auth-base.provider.ts":
/*!*********************************************!*\
  !*** ./src/auth/msal-auth-base.provider.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSALAuthBaseProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
class MSALAuthBaseProvider {
    constructor(props) {
        this.serviceUserList = [];
        this.props = Object.assign({
            ttl: 1500000,
            authority: "https://login.microsoftonline.com/",
            validateAuthority: true,
            postLogoutRedirectUri: "http://localhost:3000",
            navigateToLoginRequestUrl: true,
            loginFlow: 'redirect',
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: true,
            navigateFrameWait: 500
        }, props);
        if (!this.props.tenantUri)
            this.props.tenantUri = `https://${this.props.tenantName}.sharepoint.com`;
        const { loginToken: { name: loginTokenName }, accessTokens } = props;
        const accessTokenNames = accessTokens.map(({ name }) => name);
        this.serviceUserList = [
            loginTokenName,
            ...accessTokenNames
        ];
        this.initialiseClient();
    }
    get name() {
        return this.props.name;
    }
    get serviceUsers() {
        return this.serviceUserList;
    }
    get authority() {
        return this.props.authorityName;
    }
    authComplete({ response, redirecting }, { name }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (redirecting)
                return {
                    redirecting
                };
            const { accessToken, idToken, account } = response;
            const { loginToken: { name: loginTokenName }, name: provider, authorityName: authority, tenantId: serviceId } = this.props;
            const serviceUser = {
                name,
                provider,
                authority,
                serviceId,
                userName: account === null || account === void 0 ? void 0 : account.userName,
                token: name == loginTokenName
                    ? idToken.rawIdToken
                    : accessToken
            };
            return {
                redirecting,
                serviceUser
            };
        });
    }
    initialiseClient() { }
    getTokenPopup(authParam) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return Promise.reject();
        });
    }
    getTokenRedirect(authParam) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return Promise.reject();
        });
    }
    loginPopup() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return Promise.reject();
        });
    }
    loginRedirect() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return Promise.reject();
        });
    }
    isLoggedIn() {
        return false;
    }
    login() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isLoggedIn())
                return {
                    redirecting: false
                };
            if (this.props.loginFlow == 'popup') {
                return this.loginPopup();
            }
            return this.loginRedirect();
        });
    }
    getToken(name) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { accessTokens, loginToken, loginFlow } = this.props;
            const authParam = name == loginToken.name
                ? loginToken
                : accessTokens.find(({ name: tokenName }) => name == tokenName);
            if (loginFlow == 'popup') {
                const response = yield this.getTokenPopup(authParam);
                return this.authComplete(response, authParam);
            }
            const response = yield this.getTokenRedirect(authParam);
            return this.authComplete(response, authParam);
        });
    }
    getServiceUser(name, authContext) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { redirecting } = yield this.login();
            return !redirecting
                ? this.getToken(name)
                : {
                    redirecting
                };
        });
    }
    logout() {
        return Promise.reject();
    }
}
exports.MSALAuthBaseProvider = MSALAuthBaseProvider;


/***/ }),

/***/ "./src/auth/msal-auth.provider.ts":
/*!****************************************!*\
  !*** ./src/auth/msal-auth.provider.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSALAuthProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const msal_auth_base_provider_1 = __webpack_require__(/*! ./msal-auth-base.provider */ "./src/auth/msal-auth-base.provider.ts");
const msal_1 = __webpack_require__(/*! msal */ "msal");
class MSALAuthProvider extends msal_auth_base_provider_1.MSALAuthBaseProvider {
    constructor(props) {
        super(props);
    }
    initialiseClient() {
        const { clientId, authority, tenantId, validateAuthority, navigateFrameWait, postLogoutRedirectUri, navigateToLoginRequestUrl, cacheLocation, storeAuthStateInCookie } = this.props;
        this.userAgent = new msal_1.UserAgentApplication({
            auth: {
                clientId: clientId,
                authority: authority + tenantId,
                validateAuthority: validateAuthority,
                postLogoutRedirectUri: postLogoutRedirectUri,
                navigateToLoginRequestUrl: navigateToLoginRequestUrl
            },
            cache: {
                cacheLocation: cacheLocation,
                storeAuthStateInCookie: storeAuthStateInCookie
            },
            system: {
                navigateFrameWait: navigateFrameWait,
                logger: new msal_1.Logger((logLevel, message) => {
                    smarthub_common_1.Logger.info(logLevel + " User Agent App: " + message);
                })
            }
        });
    }
    requiresInteraction(errorMessage) {
        if (!errorMessage || !errorMessage.length)
            return false;
        return (~errorMessage.indexOf("consent_required") ||
            ~errorMessage.indexOf("interaction_required") ||
            ~errorMessage.indexOf("login_required"));
    }
    ;
    loginPopup() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const userAgent = this.userAgent;
            const { loginToken } = this.props;
            const response = yield userAgent.loginPopup(Object.assign(Object.assign({}, loginToken.request), {
                state: loginToken.name
            }));
            return {
                response
            };
        });
    }
    loginRedirect() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const userAgent = this.userAgent;
            const { loginToken } = this.props;
            userAgent.loginRedirect(Object.assign(Object.assign({}, loginToken.request), {
                state: loginToken.name
            }));
            return {
                redirecting: true,
                response: null
            };
        });
    }
    isLoggedIn() {
        var _a;
        const account = this.userAgent.getAccount();
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const expires = today.getTime() / 1000;
        return +((_a = account === null || account === void 0 ? void 0 : account.idToken) === null || _a === void 0 ? void 0 : _a.exp) > expires;
    }
    getTokenPopup(authParam) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const userAgent = this.userAgent;
            try {
                const response = yield userAgent.acquireTokenSilent(authParam.request);
                return {
                    response
                };
            }
            catch (ex) {
                if (this.requiresInteraction(ex.errorCode)) {
                    userAgent.acquireTokenPopup(Object.assign(Object.assign({}, authParam.request), {
                        state: authParam.name
                    }));
                    return {
                        redirecting: true
                    };
                }
                else
                    smarthub_common_1.Logger.error('Non-interactive error: ' + ex.errorCode, ex);
                return {};
            }
        });
    }
    getTokenRedirect(authParam) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const userAgent = this.userAgent;
            try {
                const response = yield userAgent.acquireTokenSilent(authParam.request);
                return {
                    response
                };
            }
            catch (ex) {
                if (this.requiresInteraction(ex.errorCode)) {
                    userAgent.acquireTokenRedirect(Object.assign(Object.assign({}, authParam.request), {
                        state: authParam.name
                    }));
                    return {
                        redirecting: true
                    };
                }
                else
                    smarthub_common_1.Logger.error('Non-interactive error: ' + ex.errorCode, ex);
                return {};
            }
        });
    }
}
exports.MSALAuthProvider = MSALAuthProvider;


/***/ }),

/***/ "./src/bot/cog-svc-config.provider.ts":
/*!********************************************!*\
  !*** ./src/bot/cog-svc-config.provider.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CogSvcConfigProvider = exports.CogSvcConfigProviderName = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const cacheKey = "bot-token";
exports.CogSvcConfigProviderName = "FlexBotConfigProvider";
class CogSvcConfigProvider {
    constructor(props) {
        this._props = props;
    }
    get name() {
        return exports.CogSvcConfigProviderName;
    }
    getServiceUser(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { serviceUser, redirecting } = yield auth.getServiceUser(this._props.bot.configSvc.serviceUser);
            if (!redirecting && !serviceUser)
                smarthub_common_1.Logger.error(`Could not fetch data from ${this.name}, ${this._props.bot.configSvc.serviceUser} access token not found`, true);
            return serviceUser;
        });
    }
    getOptions(user, reset) {
        var _a;
        const { cache, handle, version } = this._props.bot;
        const headers = Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, (((_a = user.token) === null || _a === void 0 ? void 0 : _a.length) ? {
            Authorization: `Bearer ${user.token}`,
        }
            : null));
        const method = version == "3" ? "POST" : "GET";
        let body = undefined;
        if (method == "POST") {
            const oldToken = cache && !reset ? smarthub_common_1.Cache.get(cacheKey, cache) : null;
            body = JSON.stringify({
                BotHandle: handle,
                OldToken: oldToken,
            });
        }
        return {
            method,
            headers,
            body,
        };
    }
    process(context, cogsvcConfig, reset) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const { cache, configSvc: { uri }, version, } = this._props.bot;
                const user = yield this.getServiceUser(context);
                if (!user)
                    return cogsvcConfig;
                const options = this.getOptions(user, reset);
                const response = yield fetch(uri, options);
                const { BotDisplayName, BotHandle, ConversationId, SpeechAPIToken, Token, TokenRefreshed, } = (yield response.json());
                if (cache) {
                    smarthub_common_1.Cache.set(cacheKey, Token, cache);
                }
                return Object.assign(Object.assign({}, cogsvcConfig), {
                    bot: Object.assign(Object.assign({}, cogsvcConfig === null || cogsvcConfig === void 0 ? void 0 : cogsvcConfig.bot), {
                        displayName: BotDisplayName,
                        conversationId: ConversationId,
                        handle: BotHandle,
                        token: Token,
                        user: {
                            tokenOnly: version === "3",
                            id: user.userName,
                            ref: user.token,
                        },
                        tokenRefreshed: TokenRefreshed,
                        personality: this._props.bot.personality,
                    }),
                    speechAPIToken: SpeechAPIToken,
                });
            }
            catch (ex) {
                smarthub_common_1.Logger.error(`Failed to retrieve config from ${this._props.bot.configSvc.uri} the message was ${ex.description}`, ex);
                throw new Error(`Failed to retrieve config from ${this._props.bot.configSvc.uri} the message was ${ex.description}`);
            }
        });
    }
}
exports.CogSvcConfigProvider = CogSvcConfigProvider;


/***/ }),

/***/ "./src/bot/index.ts":
/*!**************************!*\
  !*** ./src/bot/index.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CogSvcConfigProviderName = exports.CogSvcConfigProvider = void 0;
var cog_svc_config_provider_1 = __webpack_require__(/*! ./cog-svc-config.provider */ "./src/bot/cog-svc-config.provider.ts");
Object.defineProperty(exports, "CogSvcConfigProvider", ({ enumerable: true, get: function () { return cog_svc_config_provider_1.CogSvcConfigProvider; } }));
Object.defineProperty(exports, "CogSvcConfigProviderName", ({ enumerable: true, get: function () { return cog_svc_config_provider_1.CogSvcConfigProviderName; } }));


/***/ }),

/***/ "./src/content/aes/sharepoint-search/index.ts":
/*!****************************************************!*\
  !*** ./src/content/aes/sharepoint-search/index.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./load-sp-search-expressions.helper */ "./src/content/aes/sharepoint-search/load-sp-search-expressions.helper.ts"), exports);


/***/ }),

/***/ "./src/content/aes/sharepoint-search/load-sp-search-expressions.helper.ts":
/*!********************************************************************************!*\
  !*** ./src/content/aes/sharepoint-search/load-sp-search-expressions.helper.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.loadSPSearchExpressions = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const stringify_property_fn_1 = __webpack_require__(/*! ./stringify-property.fn */ "./src/content/aes/sharepoint-search/stringify-property.fn.ts");
const stringify_refiners_fn_1 = __webpack_require__(/*! ./stringify-refiners.fn */ "./src/content/aes/sharepoint-search/stringify-refiners.fn.ts");
const stringify_sort_fn_1 = __webpack_require__(/*! ./stringify-sort.fn */ "./src/content/aes/sharepoint-search/stringify-sort.fn.ts");
const loadSPSearchExpressions = () => {
    smarthub_common_1.addExpressionFunction({
        name: "spsearch.refiners",
        fn: stringify_refiners_fn_1.stringifyRefiners
    });
    smarthub_common_1.addExpressionFunction({
        name: "spsearch.sort",
        fn: stringify_sort_fn_1.stringifySort
    });
    smarthub_common_1.addExpressionFunction({
        name: "spsearch.prop",
        fn: stringify_property_fn_1.stringifyProperty
    });
};
exports.loadSPSearchExpressions = loadSPSearchExpressions;


/***/ }),

/***/ "./src/content/aes/sharepoint-search/stringify-property.fn.ts":
/*!********************************************************************!*\
  !*** ./src/content/aes/sharepoint-search/stringify-property.fn.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringifyProperty = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const stringifyValue = (value, wild, not) => {
    const wrap = ~value.indexOf(' ') || ~value.indexOf('-') || ~value.indexOf('/')
        ? '"'
        : '';
    return `${not}${wrap}${value.replace('\'', '\'\'')}${wild}${wrap}`;
};
const stringifyProp = (property, value, wild, op, not) => `${not}${property}${op}${stringifyValue(value, wild, '')}`;
const stringifyProperty = ([property, value, operator, wild, bool, not]) => {
    try {
        if (!(value === null || value === void 0 ? void 0 : value.length) || !(property === null || property === void 0 ? void 0 : property.length))
            return '';
        const values = Array.isArray(value)
            ? value
            : [value];
        const op = (operator === null || operator === void 0 ? void 0 : operator.length) ? operator
            : ':';
        const star = wild
            ? '*'
            : '';
        const minus = not
            ? '-'
            : '';
        if (values.length == 1)
            return stringifyProp(property, values[0], star, op, minus);
        const conditions = values
            .map(v => stringifyValue(v, star, minus))
            .join(` ${bool ? `${bool} ` : ''}`);
        return `${property}${op}(${conditions})`;
    }
    catch (ex) {
        smarthub_common_1.Logger.error(`Failed to stringifyProperty ${ex.message}`, true, {
            ex
        });
    }
    return '';
};
exports.stringifyProperty = stringifyProperty;


/***/ }),

/***/ "./src/content/aes/sharepoint-search/stringify-refiners.fn.ts":
/*!********************************************************************!*\
  !*** ./src/content/aes/sharepoint-search/stringify-refiners.fn.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringifyRefiners = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const stringifyRefiners = ([query, values]) => {
    try {
        const { refiners } = query.options || {};
        if (!(refiners === null || refiners === void 0 ? void 0 : refiners.length) || !(values === null || values === void 0 ? void 0 : values.length))
            return '';
        const items = refiners.reduce((items, { name }, idx) => {
            const val = values.length > idx
                ? values[idx]
                : null;
            return val && !smarthub_common_1.isExpr(val)
                ? [
                    ...items,
                    `${name}:${val}`
                ]
                : items;
        }, []);
        return items.length > 0
            ? items.length > 1
                ? `and(${items.join(',')})`
                : items[0]
            : '';
    }
    catch (ex) {
        smarthub_common_1.Logger.error(`Failed to stringifyRefiners ${ex.message}`, true, {
            ex
        });
    }
    return '';
};
exports.stringifyRefiners = stringifyRefiners;


/***/ }),

/***/ "./src/content/aes/sharepoint-search/stringify-sort.fn.ts":
/*!****************************************************************!*\
  !*** ./src/content/aes/sharepoint-search/stringify-sort.fn.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringifySort = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const stringifySort = ([query, sort]) => {
    try {
        const { sortOptions } = query.options || {};
        if (!(sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length))
            return '';
        const { name, direction } = sort && typeof sort === 'object'
            ? sort
            : sortOptions.find(({ preferred }) => preferred) || sortOptions[0];
        return `${name}:${direction}`;
    }
    catch (ex) {
        smarthub_common_1.Logger.error(`Failed to stringifyRefiners ${ex.message}`, true, {
            ex
        });
    }
    return '';
};
exports.stringifySort = stringifySort;


/***/ }),

/***/ "./src/content/helpers/apply-schema.fn.ts":
/*!************************************************!*\
  !*** ./src/content/helpers/apply-schema.fn.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.applySchema = void 0;
const applySchema = (result, id, { schema }) => {
    var _a;
    return Object.assign({ $id: id, $schema: typeof schema == 'string'
            ? schema
            : (_a = schema.find(({ property, value }) => result[property] == value
                || (value === undefined && property === undefined))) === null || _a === void 0 ? void 0 : _a.schema }, result);
};
exports.applySchema = applySchema;


/***/ }),

/***/ "./src/content/helpers/index.ts":
/*!**************************************!*\
  !*** ./src/content/helpers/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.applySchema = exports.transformRefiners = exports.replaceParams = void 0;
var replace_params_fn_1 = __webpack_require__(/*! ./replace-params.fn */ "./src/content/helpers/replace-params.fn.ts");
Object.defineProperty(exports, "replaceParams", ({ enumerable: true, get: function () { return replace_params_fn_1.replaceParams; } }));
var transform_refiners_fn_1 = __webpack_require__(/*! ./transform-refiners.fn */ "./src/content/helpers/transform-refiners.fn.ts");
Object.defineProperty(exports, "transformRefiners", ({ enumerable: true, get: function () { return transform_refiners_fn_1.transformRefiners; } }));
var apply_schema_fn_1 = __webpack_require__(/*! ./apply-schema.fn */ "./src/content/helpers/apply-schema.fn.ts");
Object.defineProperty(exports, "applySchema", ({ enumerable: true, get: function () { return apply_schema_fn_1.applySchema; } }));


/***/ }),

/***/ "./src/content/helpers/replace-params.fn.ts":
/*!**************************************************!*\
  !*** ./src/content/helpers/replace-params.fn.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.replaceParams = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const utc_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/utc */ "dayjs/plugin/utc"));
const replace_paramsV2_fn_1 = __webpack_require__(/*! ./replace-paramsV2.fn */ "./src/content/helpers/replace-paramsV2.fn.ts");
dayjs_1.default.extend(utc_1.default);
const replaceParams = (config, knownUris, profile, params, next, body) => {
    var _a, _b;
    return ((_b = (_a = config.request) === null || _a === void 0 ? void 0 : _a.uri) === null || _b === void 0 ? void 0 : _b.length) ? replace_paramsV2_fn_1.replaceParamsV2(config, knownUris, profile, params, next, body)
        : replaceParamsV1(config, knownUris, profile, params, next, body);
};
exports.replaceParams = replaceParams;
const replaceParamsV1 = (config, knownUris, profile, params, next, body) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const paging = Object.assign(Object.assign({}, (_a = config.request) === null || _a === void 0 ? void 0 : _a.paging), next);
    const allParams = Object.assign(Object.assign({}, params), {
        $top: paging.top,
        $skip: paging.skip,
        $refiners: (_b = config.refiners) === null || _b === void 0 ? void 0 : _b.map(r => r.name),
        $knownUris: knownUris,
        $profile: profile,
        $date: {
            today: dayjs_1.default().format("YYYY-MM-DD"),
            now: dayjs_1.default().utc().toISOString()
        }
    });
    const replacements = {
        uri: config.uri,
        method: config.method || 'GET',
        headers: (_d = (_c = config.request) === null || _c === void 0 ? void 0 : _c.headers) !== null && _d !== void 0 ? _d : [],
        body: ((_e = config.request) === null || _e === void 0 ? void 0 : _e.body) ? Object.assign(Object.assign({}, config.request.body), body !== null && body !== void 0 ? body : {}) : body
    };
    if (((_g = (_f = config.request) === null || _f === void 0 ? void 0 : _f.params) === null || _g === void 0 ? void 0 : _g.length) > 0) {
        const normalized = normalizeParams(config.request.params, allParams);
        normalized.forEach(p => {
            if (p.type == "replacement") {
                let replacement = getTargetValue(p, replacements);
                const findText = `{${p.name}}`;
                const idx = replacement.indexOf(findText);
                if (~idx) {
                    const value = getValue(p, idx);
                    const rgx = new RegExp(findText.replace(/\$/g, '\\$'), "g");
                    replacement = replacement.replace(rgx, value);
                }
                setTargetValue(replacement, p, replacements);
            }
        });
    }
    return replacements;
};
const getValue = ({ encoding, value }, index) => {
    const level = typeof encoding == 'string'
        ? encoding
        : encoding != null
            ? encoding.type
            : null;
    const encode = index != 0
        && (!(level === null || level === void 0 ? void 0 : level.length)
            || (level == 'auto'
                && value.indexOf('{') != 0
                && value.indexOf('}') != value.length - 1));
    if (encode) {
        let encoded = value;
        if (typeof encoding == 'object')
            encoded = encoding.replacements.reduce((value, { find, value: replacement }) => value.replace(new RegExp(find, 'g'), replacement), encoded);
        return encodeURIComponent(encoded);
    }
    return value;
};
const getTargetValue = (param, { uri, headers, body }) => {
    var _a, _b, _c;
    const { target } = param;
    const { type, name } = target || { type: 'uri' };
    switch (type) {
        case 'body':
            return (_a = body === null || body === void 0 ? void 0 : body[name]) !== null && _a !== void 0 ? _a : '';
        case 'header':
            return (_c = (_b = headers.find(h => h.name == name)) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '';
        default:
            return uri;
    }
};
const setTargetValue = (value, param, replacements) => {
    const { target } = param;
    const { type, name } = target || { type: 'uri' };
    const { body, headers } = replacements;
    switch (type) {
        case 'body':
            replacements.body = body !== null && body !== void 0 ? body : {};
            replacements.body[name] = value;
            break;
        case 'header':
            const header = headers.find(h => h.name == name);
            if (!header)
                headers.push({
                    name,
                    value
                });
            else
                header.value = value;
        default:
            replacements.uri = value;
            break;
    }
};
const normalizeParams = (params, values, namePath, normalized) => {
    if (!normalized)
        normalized = [];
    params.forEach(p => {
        var _a;
        if ((_a = p.params) === null || _a === void 0 ? void 0 : _a.length) {
            let children = normalizeParams(p.params, (values ? values[p.name] : ''), (namePath ? `${namePath}.${p.name}` : p.name));
            children.forEach(c => normalized.push(c));
            if (p.type != "collection")
                normalized.push(normalizeParam(p, { [p.name]: children.map(c => c.value).filter(t => t && t.length > 0) }, namePath));
        }
        else
            normalized.push(normalizeParam(p, values, namePath));
    });
    return normalized;
};
const normalizeParam = (param, values, namePath) => {
    const { alias, name, value: paramValue, type, encoding, format } = param;
    const sourceValue = values === null || values === void 0 ? void 0 : values[name];
    let value = sourceValue != null
        ? sourceValue
        : paramValue != null
            ? paramValue
            : '';
    if (format && value.length > 0) {
        let replacement = format;
        const comb = Object.assign(Object.assign({}, param), { value: value });
        const matches = format.match(/{[^\}]+}/g);
        matches.forEach(m => {
            const { groups: { arg, key, fn } = {} } = m.match(/{(?<key>\w+)(.(?<fn>\w+)(\((')?(?<arg>[^\']+)?(')?\))?)?}/);
            let val = comb[key];
            if (val) {
                switch (fn) {
                    case 'ismulti':
                        val = val.length > 1 ? arg : "";
                        break;
                    case 'join':
                        val = val.join(arg !== null && arg !== void 0 ? arg : "");
                        break;
                    case 'before':
                        val = val.substring(0, val.indexOf(arg));
                        break;
                    case 'after':
                        val = val.substring(val.indexOf(arg) + arg.length);
                        break;
                    default: val = val;
                }
                replacement = replacement.replace(m, val);
            }
            else
                replacement = replacement.replace(m, "");
        });
        value = replacement;
    }
    return {
        name: (alias === null || alias === void 0 ? void 0 : alias.length) ? alias
            : (namePath === null || namePath === void 0 ? void 0 : namePath.length) ? `${namePath}.${name}`
                : name,
        type,
        encoding,
        value
    };
};


/***/ }),

/***/ "./src/content/helpers/replace-paramsV2.fn.ts":
/*!****************************************************!*\
  !*** ./src/content/helpers/replace-paramsV2.fn.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.replaceParamsV2 = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const utc_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/utc */ "dayjs/plugin/utc"));
const query_string_1 = __webpack_require__(/*! query-string */ "query-string");
dayjs_1.default.extend(utc_1.default);
const getReplacements = ({ uri, body: bodyTemplate, method, headers, params }, bodyInput) => ({
    uri: uri || '',
    body: bodyTemplate
        ? Object.assign(Object.assign({}, bodyTemplate), bodyInput) : bodyInput,
    method: method || 'GET',
    headers: [
        ...(headers || [])
    ],
    params: [
        ...(params || [])
    ]
});
const getData = (query, knownUris, profile, data, next) => {
    const { options: { refiners: refinerList, } = {}, request: { paging: requestPaging } } = query;
    return Object.assign(Object.assign({}, data), {
        query,
        paging: Object.assign(Object.assign({}, requestPaging), next),
        refiners: refinerList === null || refinerList === void 0 ? void 0 : refinerList.map(r => r.name),
        knownUris,
        profile,
        date: {
            today: dayjs_1.default().format("YYYY-MM-DD"),
            now: dayjs_1.default().utc().toISOString()
        }
    });
};
const replaceParamsV2 = (config, knownUris, profile, data, next, bodyInput) => {
    const { request } = config;
    const replacements = getReplacements(request, bodyInput);
    const inputData = getData(config, knownUris, profile, data, next);
    const { params, uri, headers, body } = replacements;
    if (params.length || uri.includes('${') || headers.length || body)
        return transformRequest(Object.assign(Object.assign({}, request), replacements), inputData, config);
    return replacements;
};
exports.replaceParamsV2 = replaceParamsV2;
const appendHeader = (name, value, headers) => [
    ...(headers || []),
    {
        name,
        value
    }
];
const setBodyValue = (name, value, body) => name.split('.').reduce((obj, key, idx, array) => {
    if (idx == array.length - 1) {
        obj[key] = value;
        return body;
    }
    return obj[key] = Object.assign({}, obj[key]);
}, body || {});
const appendPath = (value, uri) => `${uri}${!uri.endsWith('/') ? '/' : ''}${encodeURI(concatValue(value))}`;
const concatValue = (value) => Array.isArray(value)
    ? value.map(v => typeof v == 'string'
        ? v
        : v.value).join('')
    : typeof value == 'object' && value && value.hasOwnProperty('value')
        ? value.value
        : value;
const transformRequest = (request, data, config) => {
    let { params, body, headers, uri: fullUri, method } = smarthub_common_1.transformData(request, data, config);
    let { url, query = {} } = query_string_1.parseUrl(fullUri);
    params === null || params === void 0 ? void 0 : params.forEach(({ name, target, value }) => {
        switch (target) {
            case 'header':
                headers = appendHeader(name, value, headers);
                break;
            case 'body':
                body = setBodyValue(name, value, body);
                break;
            case 'uri':
                url = appendPath(value, url);
                break;
            case 'querystring':
                query[name] = concatValue(value);
                break;
        }
    });
    const uri = query_string_1.stringifyUrl({
        url,
        query
    });
    return {
        method,
        uri,
        body,
        headers
    };
};


/***/ }),

/***/ "./src/content/helpers/transform-refiners.fn.ts":
/*!******************************************************!*\
  !*** ./src/content/helpers/transform-refiners.fn.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.transformRefiners = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const transformText = ({ type }, text) => {
    if (type == 'user') {
        const vals = text.split('|');
        return vals.length > 1
            ? vals[1]
            : vals[0];
    }
    if (type == 'date')
        return dayjs_1.default(text).format("Do MMMM YYYY");
    const sepPos = text.indexOf(';#');
    if (~sepPos)
        return text.substr(sepPos + 2);
    return text;
};
const transformEntries = (refiner, searchRefiner) => {
    const entries = !refiner.sort || refiner.sort == 'asc'
        ? searchRefiner.Entries.sort((a, b) => a.RefinementName.localeCompare(b.RefinementName))
        : refiner.sort == 'desc'
            ? searchRefiner.Entries.sort((b, a) => a.RefinementName.localeCompare(b.RefinementName))
            : searchRefiner.Entries;
    return entries.map(({ RefinementCount, RefinementValue, RefinementName, RefinementToken }) => {
        return {
            count: +RefinementCount,
            text: transformText(refiner, RefinementName),
            token: RefinementToken,
            value: RefinementValue
        };
    });
};
const transformRefiners = (refiners, query) => {
    var _a;
    const refinerDefs = query.refiners || ((_a = query.options) === null || _a === void 0 ? void 0 : _a.refiners);
    if (!refiners || !refinerDefs)
        return null;
    return refinerDefs.reduce((list, definition) => {
        const refiner = refiners.find(r => r.Name == definition.name);
        if (refiner) {
            const entry = {
                name: refiner.Name,
                text: definition.text,
                values: transformEntries(definition, refiner)
            };
            list.push(entry);
        }
        return list;
    }, []);
};
exports.transformRefiners = transformRefiners;


/***/ }),

/***/ "./src/content/index.ts":
/*!******************************!*\
  !*** ./src/content/index.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./providers */ "./src/content/providers/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./helpers */ "./src/content/helpers/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./models */ "./src/content/models/index.ts"), exports);


/***/ }),

/***/ "./src/content/models/index.ts":
/*!*************************************!*\
  !*** ./src/content/models/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./src/content/providers/action-router.provider.ts":
/*!*********************************************************!*\
  !*** ./src/content/providers/action-router.provider.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionRouterProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const nextRoute = (uri, { test, then }) => {
    const match = uri.match(test);
    const rgx = new RegExp(test);
    const next = then[+!rgx.test(uri)];
    let routeAction = '';
    if (next === null || next === void 0 ? void 0 : next.hasOwnProperty('test')) {
        routeAction = nextRoute(uri, next);
    }
    else {
        routeAction = {
            next: next,
            groups: match ? match.groups : {}
        };
    }
    return routeAction;
};
const transformAction = (route, routeAction, groups, format) => {
    const { format: template, action } = route;
    if (!template)
        return Object.assign(Object.assign({}, routeAction), action);
    const params = Object.assign(Object.assign(Object.assign({}, routeAction), route), groups);
    if (typeof template === 'string')
        return Object.assign(Object.assign({}, action), { uri: format(template, params) });
    const formatted = Object.keys(template)
        .reduce((current, key) => (Object.assign(Object.assign({}, current), { [key]: format(template[key], params) })), {});
    return Object.assign(Object.assign({}, action), formatted);
};
const queryAction = (route, action, fetch, transform) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield fetch(route.query, { action: action });
    let newAction = transform(smarthub_common_1.ActionSchema, data);
    newAction = Array.isArray(newAction) ? newAction[0] : newAction;
    const { $schema } = newAction;
    return (($schema === null || $schema === void 0 ? void 0 : $schema.length) && $schema.indexOf(smarthub_common_1.ActionSchema) == 0)
        ? newAction
        : action;
});
const transformRoute = (action, route, fetch, transform, format) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { next, groups } = nextRoute(action.uri, route);
    if (next) {
        let nextAction = transformAction(next, action, groups, format);
        if (next.query)
            nextAction = yield queryAction(next, nextAction, fetch, transform);
        if (nextAction)
            return nextAction;
        if (next.route)
            return transformRoute(Object.assign(Object.assign({}, action), { uri: action === null || action === void 0 ? void 0 : action.uri }), next.route, fetch, transform, format);
    }
    return null;
});
class ActionRouterProvider {
    constructor({ name, route }) {
        this._name = name;
        this._route = route;
    }
    get name() { return this._name; }
    route(action, fetch, transform, format) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return transformRoute(action, this._route, fetch, transform, format);
        });
    }
}
exports.ActionRouterProvider = ActionRouterProvider;


/***/ }),

/***/ "./src/content/providers/constants/index.ts":
/*!**************************************************!*\
  !*** ./src/content/providers/constants/index.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SharePointPermissionLevel = void 0;
var permission_const_1 = __webpack_require__(/*! ./permission.const */ "./src/content/providers/constants/permission.const.ts");
Object.defineProperty(exports, "SharePointPermissionLevel", ({ enumerable: true, get: function () { return permission_const_1.SharePointPermissionLevel; } }));


/***/ }),

/***/ "./src/content/providers/constants/permission.const.ts":
/*!*************************************************************!*\
  !*** ./src/content/providers/constants/permission.const.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SharePointPermissionLevel = void 0;
exports.SharePointPermissionLevel = {
    "emptyMask": 0,
    "viewListItems": 1,
    "addListItems": 2,
    "editListItems": 3,
    "deleteListItems": 4,
    "approveItems": 5,
    "openItems": 6,
    "viewVersions": 7,
    "deleteVersions": 8,
    "cancelCheckout": 9,
    "managePersonalViews": 10,
    "manageLists": 12,
    "viewFormPages": 13,
    "anonymousSearchAccessList": 14,
    "open": 17,
    "viewPages": 18,
    "addAndCustomizePages": 19,
    "applyThemeAndBorder": 20,
    "applyStyleSheets": 21,
    "viewUsageData": 22,
    "createSSCSite": 23,
    "manageSubwebs": 24,
    "createGroups": 25,
    "managePermissions": 26,
    "browseDirectories": 27,
    "browseUserInfo": 28,
    "addDelPrivateWebParts": 29,
    "updatePersonalWebParts": 30,
    "manageWeb": 31,
    "anonymousSearchAccessWebLists": 32,
    "useClientIntegration": 37,
    "useRemoteAPIs": 38,
    "manageAlerts": 39,
    "createAlerts": 40,
    "editMyUserInfo": 41,
    "enumeratePermissions": 63,
    "fullMask": 65
};


/***/ }),

/***/ "./src/content/providers/generic.provider.ts":
/*!***************************************************!*\
  !*** ./src/content/providers/generic.provider.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GenericProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/content/helpers/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
//TODO handle generic postback and fetch
class GenericProvider {
    constructor({ name, auth }) {
        this._name = name;
        this._auth = auth;
    }
    get name() { return this._name; }
    fetch(queryText, method, serviceUser, requestHeaders, bodyObj) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const body = bodyObj
                ? JSON.stringify(bodyObj)
                : undefined;
            const headers = requestHeaders.reduce((result, { name, value }) => (Object.assign(Object.assign({}, result), { [name]: value })), {
                Authorization: `Bearer ${serviceUser.token}`,
                Accept: 'application/json',
                "Content-Type": 'application/json'
            });
            return fetch(queryText, {
                method,
                headers,
                body
            });
        });
    }
    getServiceUser(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { serviceUser, redirecting } = yield auth.getServiceUser(this._auth);
            if (!redirecting && !serviceUser)
                smarthub_common_1.Logger.error(`Could not fetch data from ${this.name}, ${this._auth} access token not found`, true);
            return serviceUser;
        });
    }
    tryFetch(uri, method, query, auth, requestHeaders, body) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const serviceUser = yield this.getServiceUser(auth);
                if (!serviceUser)
                    return null;
                const { json, ok, status, statusText: message } = yield this.fetch(uri, method, serviceUser, requestHeaders, body);
                const { id, request: { paging } = { paging: null }, options, sortOptions: v1Sort } = query;
                const sortOptions = (options === null || options === void 0 ? void 0 : options.sortOptions) || v1Sort;
                const rawData = ok
                    ? yield json()
                    : null;
                const value = (_a = rawData === null || rawData === void 0 ? void 0 : rawData.value) !== null && _a !== void 0 ? _a : rawData;
                const nextUri = paging
                    ? rawData === null || rawData === void 0 ? void 0 : rawData["odata.nextLink"] : null;
                const continuation = nextUri
                    ? {
                        uri: nextUri
                    }
                    : null;
                const data = Array.isArray(value)
                    ? value.map(result => this.postProcess(result, query))
                    : value
                        ? this.postProcess(value, query)
                        : null;
                return {
                    id,
                    continuation,
                    status,
                    message,
                    data,
                    sortOptions
                };
            }
            catch (ex) {
                smarthub_common_1.Logger.error(`Could not fetch SharePoint data, ${ex}`, false, { ex, uri, query });
            }
            return null;
        });
    }
    query(query, { auth, profile, params, continuation, knownUris, body }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { uri, body: newBody, headers, method } = helpers_1.replaceParams(query, knownUris, profile, params, continuation, body);
            const { id, cache: options, cache: { hash } = {} } = query;
            let response = options && !continuation
                ? smarthub_common_1.Cache.get(id, options, hash == 'uri' ? uri : null)
                : null;
            if (!response) {
                response = yield this.tryFetch(uri, method, query, auth, headers, newBody);
                if (options)
                    smarthub_common_1.Cache.set(id, response, options, hash == 'uri' ? uri : null);
            }
            return response;
        });
    }
    submit(query, context) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query(query, context);
        });
    }
    postProcess(data, query) {
        return helpers_1.applySchema(data, data.id, query.response);
    }
}
exports.GenericProvider = GenericProvider;


/***/ }),

/***/ "./src/content/providers/html-format.provider.ts":
/*!*******************************************************!*\
  !*** ./src/content/providers/html-format.provider.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HtmlFormatProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const sanitize_html_1 = tslib_1.__importDefault(__webpack_require__(/*! sanitize-html */ "sanitize-html"));
const sanitize_options_const_1 = __webpack_require__(/*! ./sanitize-options.const */ "./src/content/providers/sanitize-options.const.ts");
const nextAction = (uri, { test, then }) => {
    const rgx = new RegExp(test);
    const next = then[+!rgx.test(uri)];
    return (next === null || next === void 0 ? void 0 : next.hasOwnProperty('test')) ? nextAction(uri, next)
        : next;
};
const transformUri = (elementUri, uriTransforms, format) => {
    return uriTransforms.reduce((uri, transform) => {
        const next = nextAction(uri, transform);
        if (next) {
            uri = next.format
                ? format(next.format, { uri })
                : uri;
            if (next.transforms)
                return transformUri(uri, next.transforms, format);
        }
        return uri;
    }, elementUri);
};
const getAttrs = (tag, className, mappings) => {
    var _a;
    const names = (_a = className === null || className === void 0 ? void 0 : className.split(' ')) !== null && _a !== void 0 ? _a : [];
    return names.reduce((attrs, name) => {
        var _a;
        const mapping = mappings.find(m => m.tag == tag && m.className == name);
        return Object.assign(Object.assign({}, attrs), ((_a = mapping === null || mapping === void 0 ? void 0 : mapping.attrs) !== null && _a !== void 0 ? _a : {}));
    }, {});
};
const transformImage = (tagName, attribs, uriTransforms, classMappings, format) => {
    const attrs = getAttrs(tagName, attribs.class, classMappings);
    const uri = transformUri(attribs.src, uriTransforms.filter(t => t.type == 'image'), format);
    return {
        tagName,
        attribs: Object.assign(Object.assign(Object.assign({}, attribs), attrs), { src: uri })
    };
};
const transformLink = (tagName, { href, className }, uriTransforms, classMappings, format) => {
    href = href == null
        ? ''
        : href;
    const attrs = getAttrs(tagName, className, classMappings);
    const uri = transformUri(href, uriTransforms.filter(t => t.type == 'link'), format);
    return {
        tagName,
        attribs: Object.assign(Object.assign({}, attrs), { href: uri, target: '_blank' })
    };
};
const transformHeading = (tagName, attribs, headingId, headings, maxNavHeading) => {
    if (tagName > maxNavHeading)
        return { tagName, attribs };
    const id = `${headingId}${headings.length}`;
    headings.push({ id, text: '', level: tagName });
    return {
        tagName,
        attribs: { id }
    };
};
const transformElement = (tagName, attribs, classMappings) => {
    const { class: className } = attribs;
    const attrs = getAttrs(tagName, className, classMappings);
    return {
        tagName,
        attribs: Object.assign(Object.assign({}, attribs), attrs)
    };
};
const updateHeadings = ({ tag, text, attribs: { id } }, headings) => {
    if (~['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].indexOf(tag) && (id === null || id === void 0 ? void 0 : id.length)) {
        const idx = headings.findIndex(h => h.id == id);
        if (~idx) {
            if ((text === null || text === void 0 ? void 0 : text.trim().length) > 0)
                headings[idx].text = text;
            else
                headings.splice(idx, 1);
        }
    }
    return false;
};
const addHeading = (heading, parent) => {
    var _a;
    const children = (_a = parent.children) !== null && _a !== void 0 ? _a : [];
    const last = children.length && children[children.length - 1];
    if (!last || last.level >= heading.level)
        parent.children = [
            ...children,
            heading
        ];
    else
        addHeading(heading, last);
};
const structureHeadings = (flatHeadings) => {
    return flatHeadings.reduce((parent, heading, idx) => {
        addHeading(heading, parent);
        return parent;
    }, {
        text: '',
        level: '0',
        id: '0',
        children: []
    }).children;
};
class HtmlFormatProvider {
    constructor({ name, classMappings, uriTransforms, sanitizeOptions }) {
        this._name = name;
        this._classMappings = classMappings;
        this._uriTransforms = uriTransforms;
        this._sanitizeOptions = sanitizeOptions;
    }
    get name() { return this._name; }
    process(dirtyContent, { headingId, maxNavHeading, formatter }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { _sanitizeOptions, _uriTransforms, _classMappings } = this;
            const flatHeadings = [];
            const options = Object.assign(Object.assign(Object.assign({}, sanitize_options_const_1.sanitizeOptions), (_sanitizeOptions !== null && _sanitizeOptions !== void 0 ? _sanitizeOptions : {})), { transformTags: {
                    a: (tagName, attribs) => transformLink(tagName, attribs, _uriTransforms, _classMappings, formatter),
                    span: (tagName, attribs) => transformElement(tagName, attribs, _classMappings),
                    p: (tagName, attribs) => transformElement(tagName, attribs, _classMappings),
                    img: (tagName, attribs) => transformImage(tagName, attribs, _uriTransforms, _classMappings, formatter),
                    h1: (tagName, attribs) => transformHeading(tagName, attribs, headingId, flatHeadings, maxNavHeading),
                    h2: (tagName, attribs) => transformHeading(tagName, attribs, headingId, flatHeadings, maxNavHeading),
                    h3: (tagName, attribs) => transformHeading(tagName, attribs, headingId, flatHeadings, maxNavHeading),
                    h4: (tagName, attribs) => transformHeading(tagName, attribs, headingId, flatHeadings, maxNavHeading),
                    h5: (tagName, attribs) => transformHeading(tagName, attribs, headingId, flatHeadings, maxNavHeading),
                    h6: (tagName, attribs) => transformHeading(tagName, attribs, headingId, flatHeadings, maxNavHeading)
                }, exclusiveFilter: (frame) => updateHeadings(frame, flatHeadings) });
            const content = sanitize_html_1.default(`<div>${dirtyContent}</div>`, options);
            const headings = structureHeadings(flatHeadings);
            return Promise.resolve({
                content,
                headings,
                type: 'raw-html'
            });
        });
    }
}
exports.HtmlFormatProvider = HtmlFormatProvider;


/***/ }),

/***/ "./src/content/providers/index.ts":
/*!****************************************!*\
  !*** ./src/content/providers/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SharePointPermissionProvider = exports.ActionRouterProvider = exports.HtmlFormatProvider = exports.GenericProvider = exports.SharePointSearchProvider = exports.SharePointODataProvider = exports.MSGraphProvider = void 0;
var ms_graph_provider_1 = __webpack_require__(/*! ./ms-graph.provider */ "./src/content/providers/ms-graph.provider.ts");
Object.defineProperty(exports, "MSGraphProvider", ({ enumerable: true, get: function () { return ms_graph_provider_1.MSGraphProvider; } }));
var sharepoint_odata_provider_1 = __webpack_require__(/*! ./sharepoint-odata.provider */ "./src/content/providers/sharepoint-odata.provider.ts");
Object.defineProperty(exports, "SharePointODataProvider", ({ enumerable: true, get: function () { return sharepoint_odata_provider_1.SharePointODataProvider; } }));
var sharepoint_search_provider_1 = __webpack_require__(/*! ./sharepoint-search.provider */ "./src/content/providers/sharepoint-search.provider.ts");
Object.defineProperty(exports, "SharePointSearchProvider", ({ enumerable: true, get: function () { return sharepoint_search_provider_1.SharePointSearchProvider; } }));
var generic_provider_1 = __webpack_require__(/*! ./generic.provider */ "./src/content/providers/generic.provider.ts");
Object.defineProperty(exports, "GenericProvider", ({ enumerable: true, get: function () { return generic_provider_1.GenericProvider; } }));
var html_format_provider_1 = __webpack_require__(/*! ./html-format.provider */ "./src/content/providers/html-format.provider.ts");
Object.defineProperty(exports, "HtmlFormatProvider", ({ enumerable: true, get: function () { return html_format_provider_1.HtmlFormatProvider; } }));
var action_router_provider_1 = __webpack_require__(/*! ./action-router.provider */ "./src/content/providers/action-router.provider.ts");
Object.defineProperty(exports, "ActionRouterProvider", ({ enumerable: true, get: function () { return action_router_provider_1.ActionRouterProvider; } }));
var sharepoint_permissions_provider_1 = __webpack_require__(/*! ./sharepoint-permissions.provider */ "./src/content/providers/sharepoint-permissions.provider.ts");
Object.defineProperty(exports, "SharePointPermissionProvider", ({ enumerable: true, get: function () { return sharepoint_permissions_provider_1.SharePointPermissionProvider; } }));


/***/ }),

/***/ "./src/content/providers/ms-graph.provider.ts":
/*!****************************************************!*\
  !*** ./src/content/providers/ms-graph.provider.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MSGraphProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/content/helpers/index.ts");
class MSGraphProvider {
    constructor({ name, auth }) {
        this._name = name;
        this._auth = auth;
    }
    get name() { return this._name; }
    fetch(queryText, method, serviceUser, requestHeaders, bodyObj) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const body = bodyObj
                ? ((bodyObj instanceof File) ? bodyObj : JSON.stringify(bodyObj))
                : undefined;
            const headers = requestHeaders.reduce((result, { name, value }) => (Object.assign(Object.assign({}, result), { [name]: value })), {
                Authorization: `Bearer ${serviceUser.token}`,
                Accept: 'application/json',
                "Content-Type": 'application/json;odata=verbose'
            });
            return fetch(queryText, {
                method,
                headers,
                body
            });
        });
    }
    getServiceUser(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { serviceUser, redirecting } = yield auth.getServiceUser(this._auth);
            if (!redirecting && !serviceUser)
                smarthub_common_1.Logger.error(`Could not fetch data from ${this.name}, ${this._auth} access token not found`, true);
            return serviceUser;
        });
    }
    tryFetch(uri, method, query, auth, requestHeaders, body) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const serviceUser = yield this.getServiceUser(auth);
                if (!serviceUser)
                    return null;
                const response = yield this.fetch(uri, method, serviceUser, requestHeaders, body);
                const { ok, status, statusText: message } = response;
                const { id, options, sortOptions: v1Sort } = query;
                const sortOptions = (options === null || options === void 0 ? void 0 : options.sortOptions) || v1Sort;
                const rawData = ok
                    ? yield response.json()
                    : null;
                const value = (_a = rawData === null || rawData === void 0 ? void 0 : rawData.value) !== null && _a !== void 0 ? _a : rawData;
                const data = Array.isArray(value)
                    ? value.map(result => this.postProcess(result, query))
                    : value
                        ? this.postProcess(value, query)
                        : null;
                return {
                    id,
                    data,
                    status,
                    message,
                    sortOptions
                };
            }
            catch (ex) {
                smarthub_common_1.Logger.error(`Could not fetch graph data, ${ex}`, false, { ex, uri, query });
            }
            return null;
        });
    }
    query(query, { auth, profile, params, knownUris, body, continuation }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { uri, body: newBody, headers, method } = helpers_1.replaceParams(query, knownUris, profile, params, continuation, body);
            const { id, cache: options, cache: { hash } = {} } = query;
            let response = options && !continuation
                ? smarthub_common_1.Cache.get(id, options, hash == 'uri' ? uri : null)
                : null;
            if (!response) {
                response = yield this.tryFetch(uri, method, query, auth, headers, newBody);
                if (options)
                    smarthub_common_1.Cache.set(id, response, options, hash == 'uri' ? uri : null);
            }
            return response;
        });
    }
    submit(query, context) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query(query, context);
        });
    }
    upload(file, query, { auth, knownUris, profile, params }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { uri, headers, method } = helpers_1.replaceParams(query, knownUris, profile, params);
            return this.tryFetch(uri, method, query, auth, headers, file);
        });
    }
    download(query, { auth, knownUris, profile, params }, type, fileName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const serviceUser = yield this.getServiceUser(auth);
            if (!serviceUser)
                return null;
            const { uri: queryUri, headers, method } = helpers_1.replaceParams(query, knownUris, profile, params);
            const response = yield this.fetch(queryUri, method, serviceUser, headers);
            const json = yield response.json();
            const downloadUri = json['@microsoft.graph.downloadUrl'];
            if (type == 'dataUri') {
                const dlResponse = yield fetch(downloadUri);
                const file = yield dlResponse.blob();
                const uri = URL.createObjectURL(file);
                return { uri };
            }
            else {
                const link = document.createElement("a");
                link.download = fileName;
                link.href = downloadUri;
                link.click();
            }
        });
    }
    flatten(item, property, list) {
        const child = item[property];
        delete item[property];
        if (child) {
            list.push(child);
            if (child[property])
                return this.flatten(child, property, list);
        }
        return list;
    }
    postProcess(data, query) {
        var _a;
        if (data && ((_a = query.response.process) === null || _a === void 0 ? void 0 : _a.flatten)) {
            const { property, result } = query.response.process.flatten;
            const flat = this.flatten(data, property, []);
            if (result == 'return')
                return flat.map(item => helpers_1.applySchema(item, item.id, query.response));
            else
                result[property] = flat;
        }
        return helpers_1.applySchema(data, data.id, query.response);
    }
}
exports.MSGraphProvider = MSGraphProvider;


/***/ }),

/***/ "./src/content/providers/sanitize-options.const.ts":
/*!*********************************************************!*\
  !*** ./src/content/providers/sanitize-options.const.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sanitizeOptions = void 0;
exports.sanitizeOptions = {
    allowedTags: [
        "address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4",
        "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div",
        "dl", "dt", "figcaption", "figure", "hr", "img", "li", "main", "ol", "p", "pre",
        "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn",
        "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp",
        "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption",
        "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "iframe"
    ],
    allowedStyles: {
        'img': {
            'width': [/^(?:\s)*\d+(?:px|em|%)(?:\s)*$/],
            'height': [/^(?:\s)*\d+(?:px|em|%)(?:\s)*$/],
            'margin': [/^(?:(?:\s)*\d+(?:px|em|%)(?:\s)*){1,4}$/]
        },
        'iframe': {
            'border': [/^none$/],
        },
        '*': {
            'font-weight': [/^\d{0,3}|normal|bold|bolder|lighter|inherit$/],
            'text-align': [/^center|left|right|start|end$/]
        }
    },
    disallowedTagsMode: 'discard',
    allowedAttributes: {
        p: ['style'],
        span: ['style'],
        a: ['href', 'name', 'target', 'data-action'],
        img: ['src', 'align', 'style'],
        iframe: ['src', 'width', 'height', 'allowfullscreen', 'style'],
        h1: ['id'],
        h2: ['id'],
        h3: ['id'],
        h4: ['id'],
        h5: ['id'],
        h6: ['id']
    },
    selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta'],
    allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel', 'data'],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false
};


/***/ }),

/***/ "./src/content/providers/sharepoint-odata.provider.ts":
/*!************************************************************!*\
  !*** ./src/content/providers/sharepoint-odata.provider.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SharePointODataProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/content/helpers/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class SharePointODataProvider {
    constructor({ name, auth }) {
        this._name = name;
        this._auth = auth;
    }
    get name() { return this._name; }
    fetch(queryText, method, serviceUser, requestHeaders, bodyObj) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const body = bodyObj
                ? JSON.stringify(bodyObj)
                : undefined;
            const headers = requestHeaders.reduce((result, { name, value }) => (Object.assign(Object.assign({}, result), { [name]: value })), {
                Authorization: `Bearer ${serviceUser.token}`,
                Accept: 'application/json',
                "Content-Type": 'application/json;odata=verbose',
                "IF-MATCH": '*'
            });
            return fetch(queryText, {
                method,
                headers,
                body
            });
        });
    }
    getServiceUser(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { serviceUser, redirecting } = yield auth.getServiceUser(this._auth);
            if (!redirecting && !serviceUser)
                smarthub_common_1.Logger.error(`Could not fetch data from ${this.name}, ${this._auth} access token not found`, true);
            return serviceUser;
        });
    }
    tryFetch(uri, method, query, auth, requestHeaders, body) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const serviceUser = yield this.getServiceUser(auth);
                if (!serviceUser)
                    return null;
                const response = yield this.fetch(uri, method, serviceUser, requestHeaders, body);
                const { ok, status, statusText: message } = response;
                const { id, request: { paging } = { paging: null }, options, sortOptions: v1Sort } = query;
                const sortOptions = (options === null || options === void 0 ? void 0 : options.sortOptions) || v1Sort;
                const contentType = response.headers.get("content-type");
                const rawData = ok && (contentType && contentType.indexOf("application/json") !== -1)
                    ? yield response.json()
                    : null;
                const value = (_a = rawData === null || rawData === void 0 ? void 0 : rawData.value) !== null && _a !== void 0 ? _a : rawData;
                const nextUri = paging
                    ? rawData === null || rawData === void 0 ? void 0 : rawData["odata.nextLink"] : null;
                const continuation = nextUri
                    ? {
                        uri: nextUri
                    }
                    : null;
                const data = Array.isArray(value)
                    ? value.map(result => this.postProcess(result, query))
                    : value
                        ? this.postProcess(value, query)
                        : null;
                return {
                    id,
                    continuation,
                    status,
                    message,
                    sortOptions,
                    data
                };
            }
            catch (ex) {
                smarthub_common_1.Logger.error(`Could not fetch SharePoint data, ${ex}`, false, { ex, uri, query });
            }
            return null;
        });
    }
    query(query, { auth, profile, params, continuation, knownUris, body }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { uri, body: newBody, headers, method } = (continuation === null || continuation === void 0 ? void 0 : continuation.uri) ? continuation
                : helpers_1.replaceParams(query, knownUris, profile, params, body);
            const { id, cache: options, cache: { hash } = {} } = query;
            let response = options && !continuation
                ? smarthub_common_1.Cache.get(id, options, hash == 'uri' ? uri : null)
                : null;
            if (!response) {
                response = yield this.tryFetch(uri, method, query, auth, headers, newBody);
                if (options)
                    smarthub_common_1.Cache.set(id, response, options, hash == 'uri' ? uri : null);
            }
            return response;
        });
    }
    submit(query, context) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query(query, context);
        });
    }
    flatten(item, property, list) {
        const child = item[property];
        delete item[property];
        list.push(child);
        if (child[property])
            return this.flatten(child, property, list);
        return list;
    }
    postProcess(data, query) {
        var _a, _b;
        if ((_b = (_a = query === null || query === void 0 ? void 0 : query.response) === null || _a === void 0 ? void 0 : _a.process) === null || _b === void 0 ? void 0 : _b.flatten) {
            const { property, result } = query.response.process.flatten;
            const flat = this.flatten(data, property, []);
            if (result == 'return')
                return flat.map(item => helpers_1.applySchema(item, item.ID, query.response));
            else
                result[property] = flat;
        }
        return helpers_1.applySchema(data, data.ID, query === null || query === void 0 ? void 0 : query.response);
    }
}
exports.SharePointODataProvider = SharePointODataProvider;


/***/ }),

/***/ "./src/content/providers/sharepoint-permissions.provider.ts":
/*!******************************************************************!*\
  !*** ./src/content/providers/sharepoint-permissions.provider.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SharePointPermissionProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/content/providers/constants/index.ts");
class SharePointPermissionProvider {
    constructor({ name, auth }) {
        this.mapLevels = (level) => {
            const spLevel = constants_1.SharePointPermissionLevel[level];
            if (spLevel !== undefined)
                return [spLevel];
            switch (level) {
                case 'read':
                    return [constants_1.SharePointPermissionLevel.viewListItems];
                case 'create':
                    return [constants_1.SharePointPermissionLevel.addListItems];
                case 'update':
                    return [constants_1.SharePointPermissionLevel.editListItems];
                case 'delete':
                    return [constants_1.SharePointPermissionLevel.deleteListItems];
                case 'edit':
                    return [
                        constants_1.SharePointPermissionLevel.viewListItems,
                        constants_1.SharePointPermissionLevel.addListItems,
                        constants_1.SharePointPermissionLevel.editListItems,
                        constants_1.SharePointPermissionLevel.deleteListItems
                    ];
                case 'admiin':
                    return [constants_1.SharePointPermissionLevel.fullMask];
                case 'approve':
                    return [constants_1.SharePointPermissionLevel.approveItems];
                default:
                    throw new Error(`Unknown permission level ${level}`);
            }
        };
        this.testLevel = (level, high, low) => {
            if (!level)
                return true;
            if (level === 65)
                return (high & 32767) === 32767 && low === 65535;
            let a = level - 1;
            let b = 1;
            if (a >= 0 && a < 32) {
                b = b << a;
                return 0 !== (low & b);
            }
            else if (a >= 32 && a < 64) {
                b = b << a - 32;
                return 0 !== (high & b);
            }
            return false;
        };
        this.testLevels = (levels, high, low) => {
            return !levels.some(l => !this.testLevel(l, high, low));
        };
        this._name = name;
        this._auth = auth;
    }
    get name() { return this._name; }
    tryFetch(queryURL, serviceUser) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch(queryURL, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${serviceUser.token}`,
                        Accept: 'application/json'
                    }
                });
                return yield response.json();
            }
            catch (ex) {
                smarthub_common_1.Logger.error(`Could not fetch sharepoint search data, ${ex}`, false, { ex, queryURL });
            }
            return null;
        });
    }
    getServiceUser(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { serviceUser, redirecting } = yield auth.getServiceUser(this._auth);
            if (!redirecting && !serviceUser)
                smarthub_common_1.Logger.error(`Could not fetch data from ${this.name}, ${this._auth} access token not found`, true);
            return serviceUser;
        });
    }
    has(permission, auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const serviceUser = yield this.getServiceUser(auth);
            if (!serviceUser || !permission)
                return false;
            let uri = '';
            const { context, right } = permission;
            const siteContext = context.find(e => e.type === 'site');
            const collectionContext = context.find(e => e.type === 'collection');
            if (collectionContext && siteContext) {
                uri = `${siteContext.id}/_api/web/lists/getbytitle('${collectionContext.id}')/EffectiveBasePermissions`;
            }
            else if (siteContext) {
                uri = `${siteContext.id}/_api/web/EffectiveBasePermissions`;
            }
            const data = yield this.tryFetch(uri, serviceUser);
            if (data) {
                const hasPermission = this.testLevels(this.mapLevels(right), data.High, data.Low);
                return Promise.resolve(hasPermission);
            }
            return Promise.resolve(false);
        });
    }
}
exports.SharePointPermissionProvider = SharePointPermissionProvider;


/***/ }),

/***/ "./src/content/providers/sharepoint-search.provider.ts":
/*!*************************************************************!*\
  !*** ./src/content/providers/sharepoint-search.provider.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SharePointSearchProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/content/helpers/index.ts");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const sharepoint_search_1 = __webpack_require__(/*! ../aes/sharepoint-search */ "./src/content/aes/sharepoint-search/index.ts");
class SharePointSearchProvider {
    constructor({ name, auth }) {
        this._name = name;
        this._auth = auth;
        sharepoint_search_1.loadSPSearchExpressions();
    }
    get name() { return this._name; }
    transformImage(value, sourceUri) {
        const search = " src=\"";
        const pos = value.indexOf(search);
        const start = search.length + pos;
        return pos >= 0
            ? sourceUri + value
                .substring(start, value.indexOf("\"", start))
            : value;
    }
    transformUser(value) {
        const user = value.split("|");
        return {
            mail: user[0].trim(),
            name: user.length > 1 ? user[1].trim() : user[0].trim(),
        };
    }
    transformLink(value) {
        return {
            uri: value.substring(0, value.indexOf(',')).trim(),
            text: value.substring(value.indexOf(',') + 1).trim(),
        };
    }
    transformDate(value) {
        return (new Date(value)).toISOString();
    }
    transformMulti(value) {
        if (value.indexOf('http') != 0 && value.indexOf('/') != 0)
            return value;
        const parts = value.split("|");
        const links = parts.map(link => {
            return {
                uri: link.substring(0, link.indexOf(',')).trim(),
                text: link.substring(link.indexOf(',') + 1).trim(),
            };
        });
        return {
            links
        };
    }
    transformTerms(value) {
        return value.split(';')
            .filter(v => v.startsWith("GP0") || v.startsWith("L0"))
            .reduce((terms, term) => {
            const { rids, ids, names, list } = terms;
            const detail = term.split('|');
            if (detail[0] == 'GP0' && detail.length == 2)
                rids.push(detail[1]);
            else if (detail[0] == 'L0' && detail.length == 3) {
                const id = detail[1];
                const text = detail[2];
                ids.push(id);
                names.push(text);
                list.push({ id, text });
            }
            return terms;
        }, {
            ids: [],
            rids: [],
            names: [],
            list: []
        });
    }
    postProcess(query, rows, sourceUri) {
        return rows.map(row => {
            const obj = {};
            row.Cells.forEach(({ Key, Value }) => {
                const k = Key.toUpperCase();
                obj[Key] = !(Value === null || Value === void 0 ? void 0 : Value.length)
                    ? ''
                    : k.endsWith("OWSIMGE") || k.endsWith("IMAGE")
                        ? this.transformImage(Value, sourceUri)
                        : k.startsWith("OWSTAXID")
                            ? this.transformTerms(Value)
                            : k.endsWith("OWSUSER")
                                ? this.transformUser(Value)
                                : k.endsWith("OWSURLH")
                                    ? this.transformLink(Value)
                                    : k.endsWith("OWSDATE")
                                        ? this.transformDate(Value)
                                        : k.endsWith("OWSMTXT")
                                            ? this.transformMulti(Value)
                                            : Value;
            });
            return helpers_1.applySchema(obj, obj.UniqueId || obj.DocId, query.response);
        });
    }
    getUri(queryText) {
        return queryText.substring(0, queryText.indexOf('/', queryText.indexOf('://') + 3));
    }
    fetch(queryText, method, serviceUser, requestHeaders, bodyObj) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const body = bodyObj
                ? JSON.stringify(bodyObj)
                : undefined;
            const headers = requestHeaders.reduce((result, { name, value }) => (Object.assign(Object.assign({}, result), { [name]: value })), {
                Authorization: `Bearer ${serviceUser.token}`,
                Accept: 'application/json',
                "Content-Type": 'application/json'
            });
            return fetch(queryText, {
                method,
                headers,
                body
            });
        });
    }
    getServiceUser(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { serviceUser, redirecting } = yield auth.getServiceUser(this._auth);
            if (!redirecting && !serviceUser)
                smarthub_common_1.Logger.error(`Could not fetch data from ${this.name}, ${this._auth} access token not found`, true);
            return serviceUser;
        });
    }
    tryFetch(uri, method, query, continuation, auth, requestHeaders, body) {
        var _a, _b, _c;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const serviceUser = yield this.getServiceUser(auth);
                if (!serviceUser)
                    return null;
                const response = yield this.fetch(uri, method, serviceUser, requestHeaders, body);
                const { ok, status, statusText: message } = response;
                const { id, options, sortOptions: v1Sort, request: { paging } = { paging: null } } = query;
                const sortOptions = (options === null || options === void 0 ? void 0 : options.sortOptions) || v1Sort;
                const data = ok
                    ? yield response.json()
                    : null;
                const result = {
                    id,
                    sortOptions,
                    status,
                    message
                };
                const results = (_a = data === null || data === void 0 ? void 0 : data.PrimaryQueryResult) === null || _a === void 0 ? void 0 : _a.RelevantResults;
                const rows = (_b = results === null || results === void 0 ? void 0 : results.Table) === null || _b === void 0 ? void 0 : _b.Rows;
                if (rows != null) {
                    const nextRows = ((paging === null || paging === void 0 ? void 0 : paging.top) + ((continuation === null || continuation === void 0 ? void 0 : continuation.skip) || (paging === null || paging === void 0 ? void 0 : paging.skip)));
                    if (nextRows < results.TotalRows)
                        result.continuation = {
                            skip: nextRows
                        };
                    result.data = this.postProcess(query, rows, this.getUri(uri));
                    result.refiners = helpers_1.transformRefiners((_c = data.PrimaryQueryResult.RefinementResults) === null || _c === void 0 ? void 0 : _c.Refiners, query);
                }
                return result;
            }
            catch (ex) {
                smarthub_common_1.Logger.error(`Could not fetch SharePoint search data, ${ex}`, false, { ex, uri, query });
            }
            return null;
        });
    }
    query(query, { auth, profile, params, continuation, knownUris, body }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { uri, body: newBody, headers, method } = helpers_1.replaceParams(query, knownUris, profile, params, continuation, body);
            const { id, cache: options, cache: { hash } = {} } = query;
            let response = options && !continuation
                ? smarthub_common_1.Cache.get(id, options, hash == 'uri' ? uri : null)
                : null;
            if (!response) {
                response = yield this.tryFetch(uri, method, query, continuation, auth, headers, newBody);
                if (options)
                    smarthub_common_1.Cache.set(id, response, options, hash == 'uri' ? uri : null);
            }
            return response;
        });
    }
    submit(query, context) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return Promise.reject();
        });
    }
}
exports.SharePointSearchProvider = SharePointSearchProvider;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
//export * from './analytics'
tslib_1.__exportStar(__webpack_require__(/*! ./auth */ "./src/auth/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bot */ "./src/bot/index.ts"), exports);
//export * from './branding'
tslib_1.__exportStar(__webpack_require__(/*! ./content */ "./src/content/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./localisation */ "./src/localisation/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./notification */ "./src/notification/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./preference */ "./src/preference/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./profile */ "./src/profile/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel */ "./src/panel/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./transform */ "./src/transform/index.ts"), exports);
//export * from './scope'


/***/ }),

/***/ "./src/localisation/index.ts":
/*!***********************************!*\
  !*** ./src/localisation/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.localizeKeys = exports.localize = void 0;
var localize_fn_1 = __webpack_require__(/*! ./localize.fn */ "./src/localisation/localize.fn.ts");
Object.defineProperty(exports, "localize", ({ enumerable: true, get: function () { return localize_fn_1.localize; } }));
Object.defineProperty(exports, "localizeKeys", ({ enumerable: true, get: function () { return localize_fn_1.localizeKeys; } }));


/***/ }),

/***/ "./src/localisation/localize.fn.ts":
/*!*****************************************!*\
  !*** ./src/localisation/localize.fn.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.localize = exports.localizeKeys = void 0;
exports.localizeKeys = {
    chatSendButtonLabel: "chatSendButtonLabel",
    chatUploadButtonLabel: "chatUploadButtonLabel",
    chatTextInputLabel: "chatTextInputLabel",
    chatTextInputPlaceholder: "chatTextInputPlaceholder"
};
const strings = {
    chatSendButtonLabel: "Click to send message",
    chatUploadButtonLabel: "Click to attach a file",
    chatTextInputLabel: "Hi, ask me a question.",
    chatTextInputPlaceholder: "Hi, ask me a question."
};
const localize = (key, defaultText) => {
    return strings[key] || defaultText;
};
exports.localize = localize;


/***/ }),

/***/ "./src/notification/index.ts":
/*!***********************************!*\
  !*** ./src/notification/index.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PollingNotificationProvider = void 0;
var polling_notification_provider_1 = __webpack_require__(/*! ./polling-notification.provider */ "./src/notification/polling-notification.provider.ts");
Object.defineProperty(exports, "PollingNotificationProvider", ({ enumerable: true, get: function () { return polling_notification_provider_1.PollingNotificationProvider; } }));


/***/ }),

/***/ "./src/notification/polling-notification.provider.ts":
/*!***********************************************************!*\
  !*** ./src/notification/polling-notification.provider.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PollingNotificationProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const utc_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/utc */ "dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
class PollingNotificationProvider {
    constructor({ name, query, timeout, initialDayOffset }) {
        this._name = name;
        this._query = query;
        this._timeout = timeout;
        this._initialDayOffset = initialDayOffset;
    }
    get name() { return this._name; }
    getNotifications(fetch, transform) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const from = (_a = this._from) !== null && _a !== void 0 ? _a : dayjs_1.default()
                    .subtract(this._initialDayOffset, 'day')
                    .utc()
                    .startOf('day')
                    .toISOString();
                const { data } = yield fetch(this._query, { from });
                const items = transform(smarthub_common_1.INotificationSchema, data !== null && data !== void 0 ? data : []);
                if (items === null || items === void 0 ? void 0 : items.length)
                    this._from = items[items.length - 1].date;
                return items;
            }
            catch (error) {
                smarthub_common_1.Logger.error('Non-interactive error: ' + error.errorCode, error);
                throw new Error(`Failed to retrieve notifications, our error code is ${error.errorCode}`);
            }
        });
    }
    listen(fetch, transform, auth) {
        return tslib_1.__asyncGenerator(this, arguments, function* listen_1() {
            let timeout = 0;
            while (true)
                yield yield tslib_1.__await(new Promise(resolve => setTimeout(() => {
                    resolve(this.getNotifications(fetch, transform));
                    timeout = this._timeout;
                }, timeout)));
        });
    }
}
exports.PollingNotificationProvider = PollingNotificationProvider;


/***/ }),

/***/ "./src/panel/index.ts":
/*!****************************!*\
  !*** ./src/panel/index.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelsBaseProvider = void 0;
var panels_base_provider_1 = __webpack_require__(/*! ./panels-base.provider */ "./src/panel/panels-base.provider.ts");
Object.defineProperty(exports, "PanelsBaseProvider", ({ enumerable: true, get: function () { return panels_base_provider_1.PanelsBaseProvider; } }));


/***/ }),

/***/ "./src/panel/panels-base.provider.ts":
/*!*******************************************!*\
  !*** ./src/panel/panels-base.provider.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelsBaseProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class PanelsBaseProvider {
    constructor(config) {
        this._uri = config.uri;
        this._auth = config.auth;
    }
    getServiceUser(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { serviceUser, redirecting } = yield auth.getServiceUser(this._auth);
            if (!redirecting && !serviceUser)
                smarthub_common_1.Logger.error(`Could not fetch data from panels, ${this._auth} access token not found`, true);
            return serviceUser;
        });
    }
    getHeaders(token) {
        return {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            "Content-Type": 'application/json'
        };
    }
    process(auth, profile) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const serviceUser = yield this.getServiceUser(auth);
            if (!serviceUser)
                return null;
            const headers = this.getHeaders(serviceUser.token);
            const response = yield fetch(`${this._uri}`, {
                method: 'GET',
                headers
            });
            return response.json();
        });
    }
}
exports.PanelsBaseProvider = PanelsBaseProvider;


/***/ }),

/***/ "./src/preference/index.ts":
/*!*********************************!*\
  !*** ./src/preference/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PreferencesBaseProvider = exports.LocalPreferencesProvider = void 0;
var local_preferences_provider_1 = __webpack_require__(/*! ./local-preferences.provider */ "./src/preference/local-preferences.provider.ts");
Object.defineProperty(exports, "LocalPreferencesProvider", ({ enumerable: true, get: function () { return local_preferences_provider_1.LocalPreferencesProvider; } }));
var preferences_base_provider_1 = __webpack_require__(/*! ./preferences-base.provider */ "./src/preference/preferences-base.provider.ts");
Object.defineProperty(exports, "PreferencesBaseProvider", ({ enumerable: true, get: function () { return preferences_base_provider_1.PreferencesBaseProvider; } }));


/***/ }),

/***/ "./src/preference/local-preferences.provider.ts":
/*!******************************************************!*\
  !*** ./src/preference/local-preferences.provider.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocalPreferencesProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const KEY_SEP = '.$';
const KEY_PREFIX = `flexai.smarthub.pref${KEY_SEP}`;
class LocalPreferencesProvider {
    constructor(type) {
        this.storage = null;
        this.storage = type == 'session'
            ? sessionStorage
            : localStorage;
    }
    get localStorage() {
        return true;
    }
    get(key, auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!(key === null || key === void 0 ? void 0 : key.length))
                throw "Preference key is empty";
            const value = this.storage.getItem(`${KEY_PREFIX}${key}`);
            return Promise.resolve({
                key,
                value,
            });
        });
    }
    getAll(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const items = [];
            if (this.storage.length > 0) {
                let idx = 0;
                while (idx < this.storage.length) {
                    const key = this.storage.key(idx++);
                    const pos = key.indexOf(KEY_PREFIX);
                    if (pos == 0 && key.length > KEY_PREFIX.length)
                        items.push({
                            key: key.substr(pos + KEY_PREFIX.length),
                            value: this.storage.getItem(key),
                        });
                }
            }
            return Promise.resolve(items);
        });
    }
    add(pref, auth) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!((_a = pref.key) === null || _a === void 0 ? void 0 : _a.length))
                throw "Preference key is empty";
            this.storage.setItem(`${KEY_PREFIX}${pref.key}`, pref.value);
            return Promise.resolve();
        });
    }
    remove(key, auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!(key === null || key === void 0 ? void 0 : key.length))
                throw "Preference key is empty";
            this.storage.removeItem(`${KEY_PREFIX}${key}`);
            return Promise.resolve();
        });
    }
    removeAll(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const prefs = yield this.getAll(auth);
            const promises = prefs.map(({ key }) => this.remove(key, auth));
            return Promise.all(promises);
        });
    }
}
exports.LocalPreferencesProvider = LocalPreferencesProvider;


/***/ }),

/***/ "./src/preference/preferences-base.provider.ts":
/*!*****************************************************!*\
  !*** ./src/preference/preferences-base.provider.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PreferencesBaseProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class PreferencesBaseProvider {
    constructor(config) {
        this._uri = config.uri;
        this._auth = config.auth;
    }
    get localStorage() {
        return false;
    }
    getServiceUser(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { serviceUser, redirecting } = yield auth.getServiceUser(this._auth);
            if (!redirecting && !serviceUser)
                smarthub_common_1.Logger.error(`Could not fetch data from preferences, ${this._auth} access token not found`, true);
            return serviceUser;
        });
    }
    getHeaders(token) {
        return {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            "Content-Type": 'application/json'
        };
    }
    get(key, auth, cacheLevel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!(key === null || key === void 0 ? void 0 : key.length))
                throw "Preference key is empty";
            const serviceUser = yield this.getServiceUser(auth);
            if (!serviceUser)
                return null;
            const headers = this.getHeaders(serviceUser.token);
            if (!headers)
                return null;
            const response = yield fetch(`${this._uri}/${key}`, {
                method: 'GET',
                headers
            });
            return response.json();
        });
    }
    getAll(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const serviceUser = yield this.getServiceUser(auth);
            if (!serviceUser)
                return null;
            const headers = this.getHeaders(serviceUser.token);
            try {
                const response = yield fetch(this._uri, {
                    method: 'GET',
                    headers
                });
                const data = yield response.json();
                return data !== null && data !== void 0 ? data : [];
            }
            catch (ex) {
                smarthub_common_1.Logger.error("Failed to retrieve preferences");
            }
            return [];
        });
    }
    add(pref, auth) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!((_a = pref.key) === null || _a === void 0 ? void 0 : _a.length))
                throw "Preference key is empty";
            const serviceUser = yield this.getServiceUser(auth);
            if (!serviceUser)
                return null;
            const headers = this.getHeaders(serviceUser.token);
            return fetch(this._uri, {
                method: 'PUT',
                headers,
                body: JSON.stringify([pref])
            });
        });
    }
    remove(key, auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!(key === null || key === void 0 ? void 0 : key.length))
                throw "Preference key is empty";
            const serviceUser = yield this.getServiceUser(auth);
            if (!serviceUser)
                return null;
            const headers = this.getHeaders(serviceUser.token);
            return fetch(`${this._uri}/${key}`, {
                method: 'DELETE',
                headers,
            });
        });
    }
    removeAll(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const prefs = yield this.getAll(auth);
            const promises = prefs.map(({ key }) => this.remove(key, auth));
            return Promise.all(promises);
        });
    }
}
exports.PreferencesBaseProvider = PreferencesBaseProvider;


/***/ }),

/***/ "./src/profile/index.ts":
/*!******************************!*\
  !*** ./src/profile/index.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryProfileProvider = void 0;
var query_profile_provider_1 = __webpack_require__(/*! ./query-profile.provider */ "./src/profile/query-profile.provider.ts");
Object.defineProperty(exports, "QueryProfileProvider", ({ enumerable: true, get: function () { return query_profile_provider_1.QueryProfileProvider; } }));


/***/ }),

/***/ "./src/profile/query-profile.provider.ts":
/*!***********************************************!*\
  !*** ./src/profile/query-profile.provider.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.QueryProfileProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const generateInitials = (names) => {
    let initials = names[0][0];
    if (names.length > 0)
        initials += names[names.length - 1][0];
    return initials.toUpperCase();
};
const generateAnyInitials = (profile) => {
    if (profile.displayName != null && profile.displayName.length > 0)
        return generateInitials(profile.displayName.split(" "));
    if (profile.surname != null && profile.surname.length > 0 && profile.givenName != null && profile.givenName.length > 0)
        return generateInitials([profile.givenName, profile.surname]);
    if (profile.surname != null && profile.surname.length > 0)
        return generateInitials([profile.surname]);
    return "";
};
class QueryProfileProvider {
    constructor({ query, name }) {
        this._name = name;
        this._query = query;
    }
    get name() {
        return this._name;
    }
    process(fetch, transform, profile) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { data } = yield fetch(this._query);
            const newProfile = transform(smarthub_common_1.IPersonSchema, data);
            newProfile.initials = generateAnyInitials(newProfile);
            return Object.assign(Object.assign({}, (profile !== null && profile !== void 0 ? profile : {})), newProfile);
        });
    }
}
exports.QueryProfileProvider = QueryProfileProvider;


/***/ }),

/***/ "./src/transform/index.ts":
/*!********************************!*\
  !*** ./src/transform/index.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformBaseProvider = void 0;
var transform_base_provider_1 = __webpack_require__(/*! ./transform-base.provider */ "./src/transform/transform-base.provider.ts");
Object.defineProperty(exports, "TransformBaseProvider", ({ enumerable: true, get: function () { return transform_base_provider_1.TransformBaseProvider; } }));


/***/ }),

/***/ "./src/transform/transform-base.provider.ts":
/*!**************************************************!*\
  !*** ./src/transform/transform-base.provider.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformBaseProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class TransformBaseProvider {
    constructor(config) {
        this._uri = config.uri;
        this._auth = config.auth;
    }
    getServiceUser(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let { serviceUser, redirecting } = yield auth.getServiceUser(this._auth);
            if (!redirecting && !serviceUser)
                smarthub_common_1.Logger.error(`Could not fetch data from transforms, ${this._auth} access token not found`, true);
            return serviceUser;
        });
    }
    getHeaders(token) {
        return {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            "Content-Type": 'application/json'
        };
    }
    process(auth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const serviceUser = yield this.getServiceUser(auth);
            if (!serviceUser)
                return null;
            const headers = this.getHeaders(serviceUser.token);
            const response = yield fetch(`${this._uri}`, {
                method: 'GET',
                headers
            });
            return response.json();
        });
    }
}
exports.TransformBaseProvider = TransformBaseProvider;


/***/ }),

/***/ "dayjs":
/*!************************!*\
  !*** external "dayjs" ***!
  \************************/
/***/ ((module) => {

module.exports = require("dayjs");

/***/ }),

/***/ "dayjs/plugin/utc":
/*!***********************************!*\
  !*** external "dayjs/plugin/utc" ***!
  \***********************************/
/***/ ((module) => {

module.exports = require("dayjs/plugin/utc");

/***/ }),

/***/ "msal":
/*!***********************!*\
  !*** external "msal" ***!
  \***********************/
/***/ ((module) => {

module.exports = require("msal");

/***/ }),

/***/ "query-string":
/*!*******************************!*\
  !*** external "query-string" ***!
  \*******************************/
/***/ ((module) => {

module.exports = require("query-string");

/***/ }),

/***/ "sanitize-html":
/*!********************************!*\
  !*** external "sanitize-html" ***!
  \********************************/
/***/ ((module) => {

module.exports = require("sanitize-html");

/***/ }),

/***/ "smarthub-common":
/*!**********************************!*\
  !*** external "smarthub-common" ***!
  \**********************************/
/***/ ((module) => {

module.exports = require("smarthub-common");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/***/ ((module) => {

module.exports = require("tslib");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.ts");
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.js.map